import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Blog Stories</h1>
            <p className="font13">
              Dive into our knowledge hub—where innovation meets practical advice. Discover tutorials, case studies, and industry breakthroughs 
              <br />
              from our ICT specialists.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Building Scalable Call Center Solutions!"
                text="Discover how to architect call center software that scales seamlessly for thousands of concurrent calls, ensuring reliability and performance.
                #Vicidial, #3CX"
                tag="company"
                author="Francis, April 18, 2022"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Data Analysis with Python: Best Practices!"
                text="Master efficient data processing using Python’s pandas library—optimize workflows and unlock actionable insights.
                #DataScience #Python"
                tag="company"
                author="James, January 08, 2023"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Modern Web Development with React!"
                text="A step-by-step guide to building responsive, high-performance web applications with React.
                #WebDev #Frontend"
                tag="company"
                author="Amby, December 28, 2024"
                action={() => alert("clicked")}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Database Management for CRM Systems!"
                text="Learn how to design optimized database schemas for Customer Relationship Management (CRM) platforms.
                #Database #UX"
                tag="company"
                author="Myles, May 20, 2025"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Custom CRM Development!"
                text="Learn how bespoke CRM systems streamline sales, support, and marketing workflows for businesses of all sizes.
                #CRM #BusinessAutomation"
                tag="company"
                author="Wycliffe, April 28, 2023"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="School ERP System!"
                text="Discover how School ERP software simplifies admissions, fee management, attendance, and parent-teacher communication.
                #EducationTech #ERP"
                tag="company"
                author="Ben M, November 20, 2024"
                action={() => alert("clicked")}
              />
            </div>
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="Load More" action={() => alert("clicked")} />
            </div>
          </div>
        </div>
      </div>
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Trusted by Industry Leaders!</h1>
            <p className="font13">
              Hear how our solutions transformed businesses—from startups to enterprises. 
              <br />
              Real results from real clients.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;